import { IApplicationState } from '../../../types/redux';

/**
 * Смотрит состояние подписки и возвращает ее факт
 */
export const selectIsSubscribed = ({ subscribe }: IApplicationState) => subscribe.status === 'ok';
